// mutation-types.js
// Store mutations here to get a quick view of what's in the campaign manager's store's state
export const MUTATION_ASSIGN_CHART = 'assignChart';